import React from 'react'
import PropTypes from 'prop-types';

export const RowTitleSection = ({title}:any) => {
    return (
        <div className="w-100 pt-2 pb-2 pl-4 gradientBlue"style={{ position:'sticky', color:'white'}}>
            <b>{title}</b>
        </div>
    )
}
RowTitleSection.propTypes = {
    title:PropTypes.string.isRequired
}